import { defineComponent as _defineComponent } from 'vue'
import { computed, useSlots } from 'vue';
import ColorService from '@/services/color.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'LpButton',
  props: {
    to: null,
    href: null,
    target: null,
    icon: null,
    iconRight: null,
    epiPropertyName: null,
    epiPropertyEdittype: null,
    color: null,
    iconInvert: { type: Boolean },
    centered: { type: Boolean, default: true },
    invert: { type: Boolean },
    border: { type: Boolean, default: true },
    ghost: { type: Boolean },
    spinner: { type: Boolean },
    disabled: null,
    isSvgIcon: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { to?: string, href?: string, target?: string, icon?: string, iconRight?: string, epiPropertyName?: string, epiPropertyEdittype?: string, color?: string, iconInvert?: boolean, centered: boolean, invert?: boolean, border: boolean, ghost?: boolean, spinner?: boolean, disabled?: any, isSvgIcon?: boolean }



const slots = useSlots();

const hasText = computed<string | null | boolean>(() => {
    try {
        return slots.default ? slots.default()[0].text : false;
    } catch (error) {
        return false;
    }
});

const isTooBright = computed<boolean>(() =>
    ColorService.isTooBright(props.color)
);

return { __sfc: true,props, slots, hasText, isTooBright }
}

})